import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import vars from "utils/vars";

// i18next instance initialization
i18n
	// i18next browser language detector initialization
	// for options see: https://www.npmjs.com/package/i18next-browser-languagedetector
	.use(new LanguageDetector())
	// react i18next initialization
	.use(initReactI18next)
	// react i18next configuration options
	// for options see: https://www.i18next.com/overview/configuration-options
	.init({
		fallbackLng: vars.app.defaultLocale,
		resources: vars.app.locales
			.map((locale) => ({ [locale]: { translation: require(`locales/${locale}.json`) } }))
			.reduce((obj, obj2) => Object.assign(obj, obj2), {}),
		debug: vars?.isDevelopment || false,
		interpolation: { escapeValue: false },
	});

export default i18n;
